module.exports = __webpack_public_path__ + "img/1f608.4d873d9.svg";